import Axios from "axios";
import auth from "./auth";
export const endpoint = process.env.REACT_APP_API_END_POINT;

export const api = Axios.create({
  baseURL: endpoint,
});
// 로그인 전(토큰 없는 상태)에 호출되는 인증 엔드포인트 — 토큰 가드 예외
const AUTH_PATHS = ["/admin/login", "/admin/certify", "/admin/verify", "/admin/pin/setup", "/admin/pin/login", "/refresh/token"];

api.interceptors.request.use((config) => {
  if (AUTH_PATHS.some((path) => (config.url || "").startsWith(path))) {
    return config;
  }
  const token = auth.getToken();
  if (!token) {
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    return Promise.reject(new Axios.Cancel("No auth token"));
  }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      !error.config._retry
    ) {
      try {
        if (auth.getRefreshToken() && auth.getRefreshToken() !== "undefined") {
          const {
            data: {
              data: { access_token, refresh_token },
            },
          } = await api.post("/refresh/token", {
            refresh_token: auth.getRefreshToken(),
          });
          auth.setToken(access_token);
          auth.setRefreshToken(refresh_token);
          api.defaults.headers.common["Authorization"] = access_token;
          error.config._retry = true;
          return api.request(error.config);
        } else {
          throw new Error();
        }
      } catch (err) {
        auth.clear("token");
        auth.clear("refreshToken");
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return null;
      }
    }
    return Promise.reject(error);
  }
);
